import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { Folder16Filled, FolderOpen16Filled, Mail16Filled } from '@fluentui/react-icons';

/**
 * Icônes des éléments listés (dossiers / mails).
 *
 * Variante « filled » + couleur, pour distinguer les deux d'un coup d'œil dans
 * les listes, à la manière de l'explorateur Windows / SharePoint :
 *  - dossier : or (Marigold — #eaa300 en thème clair, #efb839 en sombre) ;
 *  - mail    : neutre fort (blanc en thème sombre, anthracite en clair).
 *
 * Réservé aux icônes qui REPRÉSENTENT un élément existant (lignes d'arbre, de
 * tableau, de résultat de recherche). Les icônes d'ACTION (« Nouveau dossier »,
 * « Déplacer vers… ») restent en Regular neutre, comme le reste des menus.
 *
 * TAILLE 16 et non 20 : à 20 px l'icône pesait presque autant que le libellé de
 * la ligne qu'elle décore, et une arborescence en compte une par ligne. La taille
 * est portée par le composant Fluent lui-même (les variantes sont des SVG de
 * dimensions fixes) : la changer ici la change partout — arbre, tableau de la page
 * détail, résultats de recherche — sans toucher aux sites d'appel, dont aucun
 * n'impose de largeur.
 */
const useStyles = makeStyles({
  folder: { color: tokens.colorPaletteMarigoldForeground3 },
  mail: { color: tokens.colorNeutralForeground1 },
});

interface ItemIconProps {
  /** Classe du site d'appel (marges, flexShrink…). */
  className?: string;
}

// La classe couleur passe en DERNIER dans mergeClasses : elle doit l'emporter
// sur le `color` gris que portent déjà certaines classes de ligne.
export function FolderItemIcon({ className }: ItemIconProps) {
  const styles = useStyles();
  return <Folder16Filled className={mergeClasses(className, styles.folder)} />;
}

export function FolderOpenItemIcon({ className }: ItemIconProps) {
  const styles = useStyles();
  return <FolderOpen16Filled className={mergeClasses(className, styles.folder)} />;
}

export function MailItemIcon({ className }: ItemIconProps) {
  const styles = useStyles();
  return <Mail16Filled className={mergeClasses(className, styles.mail)} />;
}
